module.exports = __webpack_public_path__ + "static/media/BRL.f73f4e14.svg";